import { ReactNode } from 'react';

import Meta from '@components/Meta';
import { PageWrapperStyles } from '@common/PageWrapper';

export const PageGradientWrapper = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <div className="flex min-h-full bg-dawn-blue-100">
    <div className="mx-auto flex max-w-md flex-1 flex-col px-4">{children}</div>
  </div>
);

export const NHSPageDefaultsWrapper = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <>
    <Meta
      title="Second Nature"
      noFollow
      customProperties={{ hideIntercom: true }}
    />
    {children}
  </>
);

export const PageWrapper = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <NHSPageDefaultsWrapper>
    <PageGradientWrapper>{children}</PageGradientWrapper>
  </NHSPageDefaultsWrapper>
);

export const PageWrapperVariantA = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <NHSPageDefaultsWrapper>
    <PageWrapperStyles>{children}</PageWrapperStyles>
  </NHSPageDefaultsWrapper>
);

export const PageWrapperVitality = PageWrapperVariantA;
export const PageWrapperEmployeeVitality = PageWrapperVariantA;
export const PageWrapperThriveTribe = PageWrapperVariantA;
export const PageWrapperNdppThriveTribe = PageWrapperVariantA;
export const PageWrapperWMSL1 = PageWrapperVariantA;
export const PageWrapperWMSL3 = PageWrapperVariantA;
export const PageWrapperFullDelivery = PageWrapperVariantA;
export const PageWrapperTypeTwo = PageWrapperVariantA;
export const PageWrapperLocalWeightManagement = PageWrapperVariantA;
export const PageWrapperNdppFullDelivery = PageWrapperVariantA;
export const PageWrapperTier3WeightManagementScottishHighlands =
  PageWrapperVariantA;
export const PageWrapperTier3WeightManagementActiveWeightLoss =
  PageWrapperVariantA;
export const PageWrapperLocalWeightManagementNoTech = PageWrapperVariantA;
export const PageWrapperNDPPScotland = PageWrapperVariantA;
export const PageWrapperAdolescentWeightManagement = PageWrapperVariantA;
export const PageWrapperT3WMSH = PageWrapperVariantA;
